import { Theme } from '@mui/material';

export default function PaginationItem(theme: Theme) {
  return {
    MuiPaginationItem: {
      variants: [
        {
          props: { variant: 'outlined' },
          style: {
            textTransform: 'none',
            border: `0px`,
            color: `${theme.palette.grey[700]}`,
            '&.Mui-selected': {
              color: '#19D5C6',
            },
          },
        },
      ],
    },
  };
}
